'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useOverflowStyles", {
    enumerable: true,
    get: function() {
        return useOverflowStyles;
    }
});
const _react = require("@griffel/react");
const useOverflowStyles = /*#__PURE__*/ (0, _react.__styles)({
    overflowMenu: {
        Brvla84: "fyfkpbf"
    },
    overflowingItems: {
        zb22lx: "f10570jf"
    }
}, {
    d: [
        ".fyfkpbf [data-overflow-menu]{flex-shrink:0;}",
        ".f10570jf [data-overflowing]{display:none;}"
    ]
});
